<template>
  <div class="privacy">
    <h3>丘比粉丝俱乐部积分规则</h3>
    <h4>一、总则</h4>
    <p>
      为提升社区活跃度，鼓励用户积极参与社区互动，方便用户查阅积分获取及使用的相关规则，特制定本积分规则。本规则适用于社区所有注册用户。
    </p>
    <h4>二、积分获取规则</h4>
    <img src="../../assets/img/integral-rule2.jpg" alt="" />

    <h4>三、积分使用规则</h4>
    <p>1.积分仅限本平台积分商城内兑换奖励，不可提现或交易；</p>
    <p>
      2.积分商城兑换的实物奖励，统一安排采购，统一安排快递发放。每月28日安排当月兑换的实物奖品寄出，如果遇周六日顺延1~2日。请耐心等待；
    </p>
    <p>3.积分不可转让、合并，仅限本人账号使用。</p>
    <h4>四、积分明细查询</h4>
    <p>
      通过【签到频道】-【积分明细】查询积分余额及积分获取、使用记录。积分记录将保存最近12个月的数据，超过12个月的记录有可能会无法查询。
    </p>
    <h4>五、管理附则</h4>
    <p>
      1.用户应遵守社区积分规则及相关法律法规，严禁作弊刷分，违规将扣除积分并视情节给予警告、限制账号功能、封禁账号等处罚。
    </p>
    <p>
      2.社区有权根据运营需要对积分规则、会员等级，成就勋章等进行调整和修改，调整后的规则将在社区内公告，公告期结束后新规则自动生效。用户继续使用社区服务，即视为同意调整后的积分规则。
    </p>
    <p>3.若用户在使用积分过程中遇到任何问题，可通过客服渠道进行咨询和反馈。</p>
    <p>4.本规则自发布之日起生效，最终解释权归丘比粉丝俱乐部所有。</p>

    <h4>六、附则</h4>
    <p>1.本规则自发布之日起生效，最终解释权归丘比粉丝俱乐部所有。</p>
    <p>2.若用户在使用积分过程中遇到任何问题，可通过客服渠道进行咨询和反馈。</p>
    <p style="margin-top: 30px">更新日期：</p>
    <p>2025年06月05日</p>
  </div>
</template>
<script>
export default {
  name: "Privacy",
  components: {},
  props: {
    // props: {
    //   type: String
    // }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
.privacy {
  padding: 10px;
  background: #fff;
}
.privacy h3 {
  margin-bottom: 10px;
  text-align: center;
}
.privacy img {
  width: 100%;
}
.privacy img:nth-child(2) {
  margin-bottom: 20px;
}
.privacy img:nth-child(3) {
  margin-bottom: 20px;
}
.privacy h4 {
  margin: 10px 0;
}
.privacy p {
  text-indent: 1.5em;
  font-size: 13px;
  color: #7e7e7e;
}
.text-bold {
  font-weight: 600;
  color: #333;
}
</style>